import { UpdateAgentScopes } from "../../../types/service-types/AgentTypes";
import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { AgentService } from "../../../services";
import { errorMsg, successMsg } from "../../../utils/MessageUtils";

interface UpdateScopesStateParams {
  id: string;
  body: UpdateAgentScopes;
  onSuccess?: () => void;
  onError?: () => void;
}

const getErrorMessage = (err: any) => {
  // Axios typical shape: err.response.data.message
  return (
    err?.response?.data?.message ||
    err?.data?.message || // in case your interceptor throws {data: ...}
    err?.message ||
    "Something went wrong"
  );
};

export const updateScopes =
  (params: UpdateScopesStateParams) => async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const response = await AgentService.updateScopes(params.id, params.body);

      if (response.status >= 200 && response.status < 300) {
        dispatch(setSuccess(true));
        dispatch(
          successMsg(
            localStorage.getItem("i18nextLng") === "en"
              ? "Privileges changed successfully!"
              : "Privilegjet u ndryshuan me sukses!"
          )
        );
        dispatch(setError(""));
        params.onSuccess?.();
      } else {
        // in case backend returns non-2xx but doesn't throw
        const msg = "Privileges update failed";
        dispatch(errorMsg(msg));
        dispatch(setError(msg));
        params.onError?.();
      }
    } catch (err: any) {
      const msg = getErrorMessage(err);
      dispatch(errorMsg(msg));
      dispatch(setError(msg));
      params.onError?.();
    } finally {
      dispatch(setLoading(false));
    }
  };


interface UpdateScopesSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateScopesSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "agentedit/update-scopes",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;